import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '@service/auth.service';

@Component({
    selector: 'app-repose-toggle',
    templateUrl: './repose-toggle.component.html',
    styleUrls: ['./repose-toggle.component.scss'],
    standalone: false
})
export class ReposeToggleComponent {
    @Input() toggleModel: boolean;
    @Input() toggleModelName: string = '';
    @Output() toggleModelChange = new EventEmitter();
    @Input() checked: boolean;
    @Output() toggleCheckedClick: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private authService: AuthService) {}

    ngOnInit() {
        if (!this.toggleModelName) {
            this.toggleModel = this.checked;
        }
    }

    onModelChange(event) {
        if (this.userIsLogedIn()) {
            if (!event.target.checked) {
                this.checked = event.target.checked;
                this.toggleCheckedClick.emit(false);
            } else {
                if (!this.toggleModelName) {
                    event.target.checked = this.checked;
                }
                this.toggleCheckedClick.emit(true);
            }
            if (this.toggleModelName) {
                const updatedModel = {};
                updatedModel[this.toggleModelName] = event.target.checked;
                this.toggleModelChange.emit(updatedModel);
            }
        } else {
            event.target.checked = this.checked;
            this.toggleModel = this.checked;
        }
    }

    userIsLogedIn(): boolean {
        const currentUserId = this.authService.getCurrentUserId();
        if (!currentUserId) {
            this.toggleModel = this.checked;
            this.authService.showSignInOverlay();
            return false;
        }
        return true;
    }
}
